import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import Header from './Header';
import api from '../services/api';
import './Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.post('/api/auth/forgot-password', { email });
      
      toast.success(response.data.message || 'Password reset instructions sent!');
      setSubmitted(true);
      if (response.data.resetUrl && process.env.NODE_ENV !== 'production') {
        console.log('Reset URL:', response.data.resetUrl);
        toast.success(`Development: Reset URL logged to console`);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error?.message || 
                          error.response?.data?.message || 
                          'Failed to send reset email. Please try again.';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div>
        <Header />
        <div className="auth-container">
          <div className="auth-card">
            <div className="auth-header">
              <h1>Check Your Email &amp; Phone</h1>
              <p>We've sent password reset instructions to {email}. If we have your phone number on file, you also received a 6-digit code by SMS.</p>
            </div>
            <div className="auth-footer">
              <p>
                Didn't receive the email or code? <Link to="/forgot-password">Try again</Link> or <Link to="/reset-password">enter your code</Link>.
              </p>
              <p>
                Remember your password? <Link to="/login">Back to login</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>Forgot Password</h1>
            <p>Enter your email and we'll send you a reset link by email and a 6-digit code by SMS if we have your phone number.</p>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your email"
                disabled={loading}
              />
            </div>

            <button type="submit" className="auth-button" disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>

          <div className="auth-footer">
            <p>
              Remember your password? <Link to="/login">Back to login</Link>
            </p>
            <p>
              Don't have an account? <Link to="/register">Register here</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
